export default {
    SVOD_ID: '5d2e005cacd856260c231b01',
    DEVICE_ID: '5d48fc3fee679725a0717187',
    DATA_BUNDLE_ID: "5d444c40ee6797225cdead4b",
    CHANNEL_ID: '5d22e5e222224e2be4ad4045',
    VOD_ID: "5d22e60422224e2be4ad4046",
    PACPACKAGE_ID:"5d22e59e22224e2be4ad4044",
    CHANNEL_BUNDLE_ID : "5d35fee9acd8562438d09757"
} 